import React, {useCallback, useMemo, useState} from 'react';
import {Dialog, DialogTitle} from "@material-ui/core";
import {useMobile} from "../../../../hooks/system/useMobile";
import {UserRow} from "../../hooks/useUserLoader";
import {MenuEditClientDialog} from "./menu/MenuEditClientDialog";
import {EditPortfolio} from "./portfolio/EditPortfolio";
import {usePortfolios} from "../../../../hooks/usePortfolios";
import {useClientById} from "../../../../hooks/useClientById";

export enum EditModalTabs {
  MENU,
  BF_PORTFOLIO,
  CLIENT_PORTFOLIO
}

export interface EditClientDialogProps {
  activeUser: UserRow,
  open: boolean,
  onClose: () => void
}

export const EditClientDialog = (p: EditClientDialogProps) => {
  const isMobile = useMobile('sm'),
    [active, setActive] = useState<EditModalTabs>(EditModalTabs.MENU)

  const {portfolios} = usePortfolios(),
    {client} = useClientById(p.activeUser.relatedEntityId)

  const brokerP = useMemo(() => {
    return portfolios?.find(portfolio => portfolio.id === client?.brokerPortfolioId)
  } ,[client, portfolios])

  const clientP = useMemo(() => {
    return portfolios?.find(portfolio => portfolio.id === client?.clientPortfolioId)
  }, [client, portfolios])

  const onClose = useCallback(() => {
    setActive(EditModalTabs.MENU)
    p.onClose();
  }, [p])

  const onBackMenu = useCallback(() => setActive(EditModalTabs.MENU), [])

  return (
    <>
      <Dialog open={p.open} onClose={onClose} maxWidth='sm' fullWidth fullScreen={isMobile}>
        <DialogTitle>Edit {p.activeUser.email}</DialogTitle>
          {active === EditModalTabs.MENU && brokerP && clientP && (<MenuEditClientDialog onActive={setActive} brokerP={brokerP} clientP={clientP} onCancel={onClose} />)}
          {active === EditModalTabs.BF_PORTFOLIO && client && (<EditPortfolio client={client} variant='BF' onSubmit={onClose} activeUser={p.activeUser} onCancel={onBackMenu}/>)}
          {active === EditModalTabs.CLIENT_PORTFOLIO && client && (<EditPortfolio client={client} variant='Client' onSubmit={onClose} activeUser={p.activeUser} onCancel={onBackMenu}/>)}
      </Dialog>
    </>
  );
};
